// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__M7hKI","content":"styles_content__B7kUX","footer":"styles_footer__1e2PT"};